export enum GameAnalysisStatus {
  unknown = 'unknown',
  not_available = 'not_available',
  removed_from_app_store = 'removed_from_app_store',
  game_not_analyzed = 'game_not_analyzed',
  analyzed = 'analyzed',
}
